import { render } from "./row_action.vue?vue&type=template&id=315b3143"
import script from "./row_action.vue?vue&type=script&lang=js"
export * from "./row_action.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__